import { render } from "./editContent.vue?vue&type=template&id=34bb5d39"
import script from "./editContent.vue?vue&type=script&lang=js"
export * from "./editContent.vue?vue&type=script&lang=js"

import "./editContent.vue?vue&type=style&index=0&id=34bb5d39&lang=less"
script.render = render

export default script